<template>
  <div>
    <v-breadcrumbs :items="items" divider=">"></v-breadcrumbs>

    <v-layout text-xs-center wrap>
      <v-flex>
        <Title :title="platform"></Title>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-text-field v-model="filter" label="Filtre" placeholder="Darius, Last Resort, ..."></v-text-field>
        <Games :games="filteredGames" @go-to-game="$emit('go-to-game', $event)"></Games>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import Games from '@/components/organisms/Games.vue';
  import Title from '@/components/atoms/Title';

  export default {
    components: {
      Games,
      Title,
    },

    props: ['games', 'platform'],

    data: () => ({
      filter: '',
    }),
    computed: {
      filteredGames: {
        get() {
          const searchString = this.filter.toLocaleLowerCase().trim();
          if (!searchString) {
            return this.games;
          }
          return this.games.filter(game => game.title.toLowerCase().indexOf(searchString) >= 0);
        },
      },
      items() {
        return [
          {
            text: 'Accueil',
            disabled: false,
            href: '/',
          },
          {
            text: 'Platformes',
            disabled: false,
            href: '/platforms',
          },
          {
            text: this.platform,
            disabled: true,
            href: `/platforms/${this.platform}`,
          },
        ];
      },
    },
  };
</script>
